import constants from "./constants";

export function isBasketPage(): boolean {
  return (
    document.querySelectorAll(constants.selectors.basketContainer).length > 0
  );
}
